import { render, staticRenderFns } from "./UICheckBox.vue?vue&type=template&id=2d237fea&scoped=true"
import script from "./UICheckBox.vue?vue&type=script&lang=js"
export * from "./UICheckBox.vue?vue&type=script&lang=js"
import style0 from "./UICheckBox.vue?vue&type=style&index=0&id=2d237fea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d237fea",
  null
  
)

export default component.exports